import React from "react"
import autobind from "class-autobind"
import strings from "../../localization/strings"
import AppsIcon from "material-ui/svg-icons/navigation/apps"
import { IconButton, Paper } from "material-ui"
import { grey100 } from "material-ui/styles/colors"
import { Avatar } from "material-ui"

interface IState {
    openMenuPopup: boolean
}

export default class AppSwitchMenu extends React.Component<{}, IState> {
    constructor(props) {
        super(props)
        this.state = {
            openMenuPopup: false
        }
        autobind(this)
    }

    handleMenuPopup() {
        this.setState({ openMenuPopup: !this.state.openMenuPopup })
    }

    render() {
        return (
            <div style={{ position: "relative" }}>
                <IconButton
                    onClick={this.handleMenuPopup}
                    style={{ width: 35, height: 35, padding: 0 }}
                    iconStyle={{ width: 30, height: 30 }}
                >
                    <AppsIcon color={grey100} />
                </IconButton>
                {this.state.openMenuPopup &&
                    <Paper style={{ position: "absolute", top: 35, right: 25, zIndex: 10, }}>
                        <div style={{ display: "flex", margin: 20 }}>
                            <Avatar title={strings.TLM} onClick={() => this.setState({ openMenuPopup: false })} >
                                {strings.TLM}
                            </Avatar>
                            <Avatar
                                title={strings.HR}
                                style={{ marginLeft: 20, backgroundColor: "#d3d3d3" }}
                                onClick={(event) => {
                                    if (event.ctrlKey) {
                                        this.setState({ openMenuPopup: false }, () => window.open(hr_url(), "_blank"))
                                    } else {
                                        this.setState({ openMenuPopup: false }, () => window.location.assign(hr_url()))
                                    }
                                }}
                            >
                                {strings.HR}
                            </Avatar>
                        </div>
                    </Paper>
                }
            </div>
        )
    }
}